<template>
  <div class="star-wrap">
    <div
      v-for="i in fullNum"
      :key="'full-star' + i"
      class="one-star"
      :style="{
        width: size + 'px',
        height: size + 'px',
        marginRight: i !== allStart && spacing
      }"
    >
      <fps-icon class="star" type="star1" :size="size" :color="color" />
    </div>
    <div
      v-if="hashalf"
      class="one-star"
      :style="{
        width: size + 'px',
        height: size + 'px',
        marginRight: fullNum !== allStart - 1 && spacing
      }"
    >
      <fps-icon class="star" type="star1" :size="size" color="#EEEEEE" />
      <fps-icon class="star" type="star1-half" :size="size" :color="color" />
    </div>
    <div
      v-for="i in nullNum"
      :key="'null-star' + i"
      class="one-star"
      :style="{
        width: size + 'px',
        height: size + 'px',
        marginRight: nullNum !== i && spacing
      }"
    >
      <fps-icon class="star" type="star1" :size="size" color="#EEEEEE" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
    allStart: {
      type: Number,
      default: 5
    },
    size: {
      type: Number,
      default: 12
    },
    color: {
      // 星星亮色
      type: String,
      default: '#F7B500'
    },
    spacing: {
      // 星星之间的间距
      type: String,
      default: '4px'
    }
  },
  data() {
    return {};
  },
  computed: {
    countValue() {
      return this.count || 0;
    },

    fullNum() {
      return parseInt(this.countValue);
    },
    hashalf() {
      return this.fullNum != this.countValue;
    },
    nullNum() {
      return this.allStart - this.fullNum - (this.hashalf ? 1 : 0);
    }
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.star-wrap {
  @include flex;
  font-size: 0;
  .one-star {
    position: relative;
    .star {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
